module.exports = __webpack_public_path__ + "assets/img/my-bg-vip.b9a549fd.png";